/* ═══════════════════════════════════════════════════════════════════
   SERENE RING — Product Page JS
   ──────────────────────────────────────────────────────────────────
   Sales-support collapse / "Read more" toggle.
   Mobile-only davranış; desktop'ta tam metin gösterilir (CSS).
   Body 260px'ten yüksekse collapse aktif olur.

   Önceden main-product.liquid içine inline <script> olarak
   gömülmüştü. 29 APR 2026'da kod temizliği kapsamında bu dosyaya
   taşındı.
   ═══════════════════════════════════════════════════════════════════ */
/* ─────────────────────────────────────────────────────────
   SERENE — Sales-support collapse / "Read more" toggle
   Mobile-only behaviour; desktop shows full text (CSS).
   Activates only if the body is actually tall enough that
   collapsing adds value (>260px). Keeps desktop untouched.
   ───────────────────────────────────────────────────────── */
(function(){
  function initSereneCollapsibles(){
    var wrappers = document.querySelectorAll('[data-serene-collapsible]');
    if (!wrappers.length) return;

    wrappers.forEach(function(wrapper){
      if (wrapper.dataset.sereneBound === '1') return;
      wrapper.dataset.sereneBound = '1';

      var body   = wrapper.querySelector('.serene-sales-support__body');
      var toggle = wrapper.querySelector('[data-serene-collapsible-toggle]');
      if (!body || !toggle) return;

      // If content is short, hide toggle and show full text
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      if (isMobile && body.scrollHeight <= 260) {
        toggle.style.display = 'none';
        body.classList.remove('is-collapsible');
        return;
      }

      toggle.addEventListener('click', function(){
        var expanded = body.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        var label = toggle.querySelector('.serene-sales-support__toggle-label');
        if (label) label.textContent = expanded ? 'Show less' : 'Read more';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSereneCollapsibles);
  } else {
    initSereneCollapsibles();
  }
  // Re-init on Shopify theme editor section load
  document.addEventListener('shopify:section:load', initSereneCollapsibles);
})();

/* ─────────────────────────────────────────────────────────
   SERENE — Slick slidesToShow override
   ──────────────────────────────────────────────────────────
   30 APR 2026 KALDIRILDI:
   Bu blok eskiden productthumbs()'un slidesToShow:5 değerini
   runtime'da 4/3'e patliyordu (FOUC yaratıyordu). Artık
   sections/main-product.liquid içindeki productthumbs() doğru
   değerlerle (4 desktop / 3 mobile) init ediyor; override
   gereksiz. Kod bloğu temizlendi. Eski versiyona git history'den
   ulaşılabilir.
   ───────────────────────────────────────────────────────── */
